export const URL_PRODUCT_PERMISSIONS_DOC = 'https://octonus-teams.com/wiki/x/zgpbBg';
export const URL_STOCK_MANAGEMENT_DOC = 'https://octonus-teams.com/wiki/x/ygpbBg';
